// extracted by mini-css-extract-plugin
export default {"wrapper":"BrowseEventsLink_wrapper__DXuGf","link":"BrowseEventsLink_link__L0nHV","arrowButton":"BrowseEventsLink_arrowButton__KdK63","arrowIcon":"BrowseEventsLink_arrowIcon__2SWM9"};